/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Cancel_Reason_OtherInputs */

const en_settings_cancel_reason_other = /** @type {(inputs: Settings_Cancel_Reason_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const id_settings_cancel_reason_other = /** @type {(inputs: Settings_Cancel_Reason_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lainnya`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Settings_Cancel_Reason_OtherInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_cancel_reason_other = /** @type {((inputs?: Settings_Cancel_Reason_OtherInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Cancel_Reason_OtherInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_cancel_reason_other(inputs)
	return en_settings_cancel_reason_other(inputs)
});